import { copy } from '@/helpers/object';
import BookmarkedAttrs from '@/interface/BookmarkedAttrs';
import { formatBookmarkedJobs } from '@/app/store/_job-list-item-formatter';

const state = () => ({
  isLoading: false,

  list: [],
});

const mutations = {
  setLoading(s, newValue) {
    s.isLoading = newValue;
  },
  setList(s, newValue) {
    s.list = newValue;
  },
  removeBookmarkedItem(s, item) {
    s.list = s.list.filter(({ id }) => id !== item.id);
  },
};

const actions = {
  fetch({ commit }) {
    commit('setLoading', true);
    commit('setList', []);

    const url = this.getters.getApiLink('job.getAllMarked');

    return this.$api
      .get(url)
      .then(({ data }) => {
        const list = (data || []).map(formatBookmarkedJobs);
        commit('setList', list);

        return copy(list);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  saveBookmarked(_, attrs: BookmarkedAttrs) {
    const { id, value } = attrs;
    const urlKey = value ? 'mark' : 'unmark';
    const apiMethod = value ? 'post' : 'delete';

    return this.$api[apiMethod](
      this.getters.getApiLink(`job.${urlKey}`, {
        uid: id,
      }),
    ).catch((error) => {
      console.error(error);
      throw new Error('Something goes wrong');
    });
  },
  removeBookmarkedItem({ commit }, item) {
    commit('removeBookmarkedItem', item);
  },
};

const getters = {
  loading: (s) => s.isLoading,
  list: (s) => s.list,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
